import React from 'react';
import { PapiSession, PapiUser } from '@wix/da-papi-types';
import { ThemeOptions, ThemeSkin } from '../ThemeContext';

export type ThreadOrder = 'newest' | 'oldest';

export interface PublicSessionState {
  isLoggedIn: boolean;
  isMobile: boolean;
  isVerified: boolean;
  isUnverified?: boolean;
  verificationEmail?: string;
  csrfToken?: string;
  country?: string;
  joinDate?: string;
  timezone?: string;
  user: number | PapiUser | PapiSession['user'];
  counts?: PapiSession['counts'];
  theme: ThemeOptions;
  themeSkin?: ThemeSkin;
  showMatureContent: boolean;
  contentFilter: PapiSession['user']['contentFilter'];
  aiContentFilter: PapiSession['user']['aiContentFilter'];
  hasCoreMembership: boolean;
  coreLevel?: CoreLevel;
  isActiveCoreUpgradeable?: boolean;
  coreExpires?: string;
  hasJoinedWithEclipse: boolean;
  requestId: string;
  useridUuid?: string;
  biClientId?: string;
  biClientIdSigned?: string;
  commentsOrder: ThreadOrder;
  feedbackUrl?: string;
  pagingMode?: string;
  pageSize?: number;
  deviationViewMode: DeviationViewMode;
  seo: {
    title: string;
    description: string;
    canonical: string;
    socialThumbSrc: string;
    prev?: string;
    next?: string;
    rating?: string;
    robots?: string;
  };
  updateProgress?: {
    isResendInProgress?: boolean;
    isEmailChangeInProgress?: boolean;
    isSendingDone?: boolean;
    updateFailed?: boolean;
  };
  eclipseSwitcher?: boolean;
  device?: {
    isMobile?: boolean;
    isMobileDevice?: boolean;
    isTablet?: boolean;
    supportsWebp?: boolean;
    supportsLazy?: boolean;
    isIos?: boolean;
  };
  hub?: PapiSession['hub'];
  hasAcceptedCookies: boolean;
  cookiePrivacyRequired: boolean;
  cookiePrivacySettings: CookieSettingsTypes;
  chat?: {
    muteSound?: boolean;
    muted?: boolean;
    online?: boolean;
  };
  damz?: PapiSession['damz'];
  dre?: PapiSession['dre'];
  promos?: PapiSession['promos'];
  limitedBadgesPromo?: PapiSession['limitedBadgesPromo'];
  appIds?: PapiSession['appIds'];
  abTests?: PapiSession['abtests'];
  requiresNonEuGdpr?: boolean;
  sessionId?: string;
  ppId?: string;
  push: PapiSession['push'];
  language?: string;
}

export type CookieSettingsTypes = {
  functional: boolean;
  marketing: boolean;
  analytics: boolean;
};

export enum DeviationViewMode {
  Theater = 'theater',
  Fullscreen = 'fullscreen',
  Normal = 'regular',
}

export type CoreLevel = PapiSession['user']['coreLevel'];
export type Promo = NonNullable<PublicSessionState['promos']>[0];

export const SessionContext = React.createContext<PublicSessionState>({
  isLoggedIn: false,
} as PublicSessionState);
SessionContext.displayName = 'SessionContext';
